import { render, staticRenderFns } from "./pageArticModule.vue?vue&type=template&id=3a809810"
import script from "./pageArticModule.vue?vue&type=script&lang=js"
export * from "./pageArticModule.vue?vue&type=script&lang=js"
import style0 from "./pageArticModule.vue?vue&type=style&index=0&id=3a809810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports